// extracted by mini-css-extract-plugin
export default {"menuOpen":"Options_menuOpen__OIHlP"};